import React from "react";
import { Card, Text, Divider } from "@nextui-org/react";
import { motion } from "framer-motion";

const MotionCard = motion(Card);

const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  return isNaN(d.getTime())
    ? dateStr
    : d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

const AltEntryCard = ({ doc, checked, onToggle }) => {
  const qty = Number(doc?.qty || 1);
  const unitSunil = Number(doc?.amount || 0);
  const unitCust = Number(doc?.customerAmount || 0);
  const sunilAmt = unitSunil * qty;
  const custAmt = unitCust * qty;
  const profit = custAmt - sunilAmt;

  return (
    <div className="linkWidth" onClick={() => onToggle?.(doc._id)}>
      <MotionCard
        variant="bordered"
        css={{
          mw: "550px",
          cursor: "pointer",
        }}
        whileTap={{ scale: 0.9, transition: { duration: 0.1 } }}
      >
        <Card.Header
          css={{
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "5px",
          }}
        >
          <Text b size="14px">
            {doc?.phone || "Unknown Phone"}
          </Text>

          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            {doc?.isCleared && (
              <Text
                b
                size="12px"
                css={{
                  br: "12px",
                  bgColor: "$teal50",
                  px: "10px",
                  py: "5px",
                }}
                color="$teal800"
              >
                Cleared
              </Text>
            )}
            {doc?.category && (
              <Text
                b
                size="12px"
                css={{
                  br: "12px",
                  bgColor: doc.category === "shop" ? "$warningLight" : "$blueLight",
                  px: "10px",
                  py: "5px",
                }}
                color={doc.category === "shop" ? "$warning" : "$blue800"}
              >
                {doc.category === "shop" ? "Shop" : "Customer"}
              </Text>
            )}
            <Text
              b
              size="12px"
              css={{
                br: "12px",
                bgColor: "$red50",
                px: "10px",
                py: "5px",
              }}
              color="$red800"
            >
              Entry
            </Text>
            <input
              type="checkbox"
              checked={!!checked}
              onChange={() => onToggle?.(doc._id)}
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                accentColor: "#ff385c",
                marginLeft: "4px",
              }}
            />
          </div>
        </Card.Header>
        <Card.Divider />
        <Card.Body
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            py: "5px",
            alignItems: "center",
          }}
        >
          <div className="groupCardFlex">
            <Text size="13px" b>
              Sunil:
            </Text>
            <Text size="13px" b color="error">
              {qty > 1
                ? `+ \u20B9 ${unitSunil.toLocaleString("en-IN")} x ${qty} = \u20B9 ${Math.ceil(sunilAmt).toLocaleString("en-IN")}`
                : `+ \u20B9 ${Math.ceil(sunilAmt).toLocaleString("en-IN")}`}
            </Text>
          </div>

          {custAmt > 0 && doc?.category === "customer" && (
            <>
              <Divider />
              <div className="groupCardFlex">
                <Text size="13px" b>
                  Cust Amt:
                </Text>
                <Text size="13px" b color="default">
                  {qty > 1
                    ? `\u20B9 ${unitCust.toLocaleString("en-IN")} x ${qty} = \u20B9 ${Math.ceil(custAmt).toLocaleString("en-IN")}`
                    : `\u20B9 ${Math.ceil(custAmt).toLocaleString("en-IN")}`}
                </Text>
              </div>

              <Divider />
              <div className="groupCardFlex">
                <Text size="13px" b>
                  Profit:
                </Text>
                <Text size="13px" b color={profit >= 0 ? "secondary" : "error"}>
                  {profit >= 0 ? "+" : ""} &#8377;{" "}
                  {Math.ceil(profit).toLocaleString("en-IN")}
                </Text>
              </div>
            </>
          )}

          {doc?.customer && (
            <>
              <Divider />
              <div className="groupCardFlex">
                <Text size="13px" b>
                  Customer:
                </Text>
                <Text size="13px" b>
                  {doc.customer}
                </Text>
              </div>
            </>
          )}

          <Divider />
          <div className="groupCardFlex">
            <Text size="13px" b>
              Contact:
            </Text>
            <Text size="13px" b>
              {doc?.customerPhone || "N/A"}
            </Text>
          </div>

          {doc?.issue && (
            <>
              <Divider />
              <div className="groupCardFlex">
                <Text size="13px" b>
                  Issue:
                </Text>
                <Text
                  size="13px"
                  b
                  css={{
                    maxW: "65%",
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  {doc.issue}
                </Text>
              </div>
            </>
          )}

          <Divider />
          <div className="groupCardFlex">
            <Text size="12px" color="$gray700">
              Created:
            </Text>
            <Text size="12px" color="$gray700">
              {formatDate(doc?.created)}
            </Text>
          </div>

          {doc?.clearedAt && (
            <>
              <Divider />
              <div className="groupCardFlex">
                <Text size="12px" color="$teal800" b>
                  Cleared:
                </Text>
                <Text size="12px" color="$teal800" b>
                  {formatDate(doc.clearedAt)}
                </Text>
              </div>
            </>
          )}

          {(doc?.lastEditedAt || doc?.editHistory?.length > 0) && (
            <Text size="11px" color="$gray600" css={{ margin: 0 }}>
              Edited on{" "}
              {formatDate(
                doc?.lastEditedAt ||
                  doc?.editHistory?.[doc.editHistory.length - 1]?.editedAt
              )}
            </Text>
          )}
        </Card.Body>
      </MotionCard>
    </div>
  );
};

export default AltEntryCard;
